<ng-container *transloco="let t">
  <div class="chatbot-widget">
    @if (isOpen) {
      <div class="chatbot-window">
        <div class="chatbot-header">
          <h4>{{ t('chatbot_title') }}</h4>
          <button
            class="close-btn"
            (click)="toggleChat()"
            [attr.aria-label]="t('chatbot_close')"
          >
            <lib-icon name="x" size="medium"></lib-icon>
          </button>
        </div>
        <div
          class="messages-container"
          #messagesContainer
          role="log"
          aria-live="polite"
        >
          <div class="privacy-notice">
            @let userAgreementLink = t('chatbot_useragreement_link');
            <p>{{ t('chatbot_privacy_notice_text') }}</p>
            @if (
              userAgreementLink !== '' &&
              userAgreementLink !== 'chatbot_useragreement_link'
            ) {
              <a
                [href]="userAgreementLink"
                target="_blank"
                rel="noopener noreferrer"
                >{{ t('chatbot_useragreement_link_text') }}</a
              >
            }
          </div>
          @if (personName) {
            <div class="message bot-message greeting-message">
              <div class="message-content" [innerHTML]="getGreeting(t)"></div>
            </div>
          }
          @if (isOpen) {
            <div class="message bot-message">
              <div
                class="message-content"
                [innerHTML]="convertNewlinesToBr(t('chatbot_welcome_message'))"
              ></div>
            </div>
          }
          @for (message of messages; track message) {
            <div
              class="message"
              [class.user-message]="message.sender === 'user'"
              [class.bot-message]="message.sender === 'bot'"
              [class.greeting-message]="message.messageType === 'greeting'"
            >
              @if (message.sanitizedContent) {
                <div
                  class="message-content"
                  [innerHTML]="message.sanitizedContent"
                ></div>
              }
              @if (message.citations && message.citations.length > 0) {
                <div class="sources">
                  <span class="source-headline">
                    {{ t('chatbot_sources_headline') }}
                  </span>
                  @for (citation of message.citations; track citation) {
                    <a
                      [href]="citation.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="source-item"
                    >
                      <span class="source-number">{{
                        citation.docNumber
                      }}</span>
                      <span class="source-text">{{ citation.title }}</span>
                    </a>
                  }
                </div>
              }
            </div>
          }
          @if (isTyping) {
            <div
              class="message bot-message"
              aria-label="{{ t('chatbot_typing') }}"
            >
              <div class="typing-dots">
                <span class="typing-dot"></span><span class="typing-dot"></span
                ><span class="typing-dot"></span>
              </div>
            </div>
          }
        </div>
        <div class="input-container">
          <div
            class="message-input"
            #messageInputElement
            contenteditable="true"
            role="textbox"
            aria-label="{{ t('chatbot_input_placeholder') }}"
            aria-multiline="true"
            [attr.aria-disabled]="isTyping"
            (keydown.enter)="onEnterKey($event)"
            (input)="onInput($event)"
            (mousedown)="onMouseDown()"
            (focus)="onFocus()"
            (blur)="onBlur()"
            [tabIndex]="0"
            [attr.data-placeholder]="
              messageInput ? null : t('chatbot_input_placeholder')
            "
            [attr.contenteditable]="!isTyping"
          ></div>
          <button
            class="send-button"
            [attr.tabindex]="!messageInput.trim() && !isTyping ? -1 : 0"
            (mousedown)="onSendButtonMouseDown($event)"
            (click)="isTyping ? chatbotService.stopTyping() : sendMessage()"
            [disabled]="!messageInput.trim() && !isTyping"
            [attr.aria-label]="t('chatbot_send')"
          >
            @if (!isTyping) {
              <lib-icon name="send"></lib-icon>
            }
            @if (isTyping) {
              <img
                src="assets/chatbot/white-square-icon.svg"
                alt="{{ t('chatbot_stop_typing') }}"
              />
            }
          </button>
        </div>
      </div>
    }
    <button
      #chatToggleButton
      class="chatbot-toggle"
      [class.chatbot-open]="isOpen"
      [attr.aria-label]="t(isOpen ? 'chatbot_close' : 'chatbot_open')"
      [attr.aria-expanded]="isOpen"
      [tabIndex]="0"
      (click)="toggleChat()"
    >
      @if (isOpen) {
        <lib-icon name="x"></lib-icon>
      }
      @if (!isOpen) {
        <img
          src="assets/chatbot/chatIcon.svg"
          alt="{{ t('chatbot_open') }}"
          aria-hidden="true"
        />
      }
    </button>
  </div>
</ng-container>
